import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Input, Output, EventEmitter, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, Validators } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { InsuredService } from '@services/insured.service';
import { CoreModule } from 'app/modules/core.module';
import { NumberPipe } from 'app/pipes/number.pipe';
import { RutValidator, stringFormat } from 'app/validators/iatuch.validators';
import { StateDisplayComponent } from 'app/shared/state-display/state-display.component';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-personal-information',
  standalone: true,
  imports: [CoreModule, NgSelectComponent, NumberPipe, StateDisplayComponent],
  providers: [InsuredService],
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalInformationComponent implements OnInit {

  @Input() insured: any
  @Input() editData: boolean = true
  @Input() permissions: any
  @Output() update = new EventEmitter<any>()

  private fb: FormBuilder = inject(FormBuilder)
  private _insuredService: InsuredService = inject(InsuredService)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  protected age: Number
  protected listGenders = []
  protected listPositions = []

  public personalDataForm: any

  private formControls = {
    _id: [null],
    rut: [null, [Validators.required]],
    dv: [null, [Validators.required]],
    names: [null, [Validators.required]],
    surname: [null, [Validators.required]],
    lastname: [null, [Validators.required]],
    genderId: [null, [Validators.required]],
    birthdate: [null, [Validators.required]],
    jobTitleId: [null],
    phone: [null, [Validators.required]],
    mail: [null, [Validators.required]]
  }

  ngOnInit(): void {
    this.personalDataForm = this.fb.group(this.formControls)
  }

  editDataForm() {
    this.editData = true
    this.setDataToForm()
  }

  private _buildFormValue() {
    const v = this.personalDataForm.value
    return { ...v, names: v.names.trim(), surname: v.surname.trim(), lastname: v.lastname.trim(), mail: v.mail.trim() }
  }

  private _onUpdateSuccess(res: any) {
    this.editData = false
    this.insured = res.insured
    this.update.emit(res.insured)
    this.cdr.markForCheck()
  }

  private _onUpdateError() {
    Swal.fire('Error', 'No se pudo actualizar el asegurado', 'error')
  }

  saveData() {
    if (!this.personalDataForm.valid) {
      this.personalDataForm.markAllAsTouched()
      return
    }
    this._insuredService.update(this._buildFormValue()).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: res => this._onUpdateSuccess(res),
      error: () => this._onUpdateError()
    })
  }

  cancelEdit() {
    this.editData = false
  }

  setDataToForm() {
    this.personalDataForm.patchValue({ ...this.insured, birthdate: this.insured.birthdate.slice(0, 10) })
    this.getGenders()
    this.getPositions()
  }


  getGenders() {
    this._insuredService.getGenders().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      this.listGenders = res
      this.cdr.markForCheck()
    })
  }

  getPositions(){
    this._insuredService.getPositions(this.insured._id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      this.listPositions = res
      this.cdr.markForCheck()
    })
  }

  // private setupValidators(code) {
  //   if(code == 'H') this.personalDataForm.get('birthdate').setValidators([Validators.required, dateValidator.validateFutureDate]); 
  //   else this.personalDataForm.get('birthdate').setValidators([Validators.required, dateValidator.validateAdult, dateValidator.validateFutureDate]);
  //   this.personalDataForm.get('birthdate').updateValueAndValidity();
  // }
  setDigitVerificator() {
    const dv = RutValidator.setDigitVerificator(this.personalDataForm.value.rut)
    this.personalDataForm.patchValue({
      dv: dv
    })
  }

  public capitalize(controlName: String) {
    const control = this.personalDataForm.get(controlName);
    if (control) {
      stringFormat.capitalizeAll(control);
    }
  }
}
